
export const CHANGE_LOADING_STATUS = "CHANGE_LOADING_STATUS";
export const SET_SAVING_HAISAI_CITIZEN_SECTION_SERVICE_ONE = "SET_SAVING_HAISAI_CITIZEN_SECTION_SERVICE_ONE";
export const SET_SAVING_NATIONAL_HEALTH_INSURANCE_SECTION = "SET_SAVING_NATIONAL_HEALTH_INSURANCE_SECTION";
export const SET_SAVING_CITIZEN_LIFE_SAFETY_SECTION = "SET_SAVING_CITIZEN_LIFE_SAFETY_SECTION";
